import React from 'react'
import "./Logout.css"

 const Logout = () => {
     return(
         <div className='logout' style={{margin: "8rem 0"}}>Logout</div>
     )
 }

 export {Logout}